import { useRef } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FormGroup } from "../../../components/FormGroup";
import { FormLabel } from "../../../components/FormLabel";
import { Input } from "../../../components/Input";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";

const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;
`;

const FileNameDisplay = styled.div`
  padding: ${spacing.x2}px;
  background-color: ${colors.backgroundLight};
  border: 1px solid ${colors.border};
  border-radius: 4px;
  color: ${colors.text};
`;

const DropHint = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${colors.textMuted};
`;

interface CsvFileUploadProps {
  file: File | null;
  onFileChange: (file: File | null) => void;
}

export const CsvFileUpload = ({ file, onFileChange }: CsvFileUploadProps) => {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    onFileChange(selectedFile);
  };

  return (
    <FileInputContainer>
      <FormGroup>
        <FormLabel>{t("import.csvFileLabel")}</FormLabel>
        <Input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          onChange={handleChange}
          required
        />
        {file && (
          <FileNameDisplay>
            {t("import.selectedFileKb", {
              name: file.name,
              size: (file.size / 1024).toFixed(2),
            })}
          </FileNameDisplay>
        )}
        <DropHint>{t("import.dropFileHint")}</DropHint>
      </FormGroup>
    </FileInputContainer>
  );
};
